export default __webpack_public_path__ + "static/media/power-icon.f94ae9d9.svg";